"use strict";
exports.__esModule = true;
exports.chart_global_layout_Height = {
  "name": "--pf-chart-global--layout--Height",
  "value": 300,
  "var": "var(--pf-chart-global--layout--Height, 300)"
};
exports["default"] = exports.chart_global_layout_Height;